var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9625 13.8333L0.25 16.75V1.33333C0.25 1.11232 0.337797 0.900358 0.494078 0.744078C0.650358 0.587797 0.86232 0.5 1.08333 0.5H16.0833C16.3043 0.5 16.5163 0.587797 16.6726 0.744078C16.8289 0.900358 16.9167 1.11232 16.9167 1.33333V13C16.9167 13.221 16.8289 13.433 16.6726 13.5893C16.5163 13.7455 16.3043 13.8333 16.0833 13.8333H3.9625ZM1.91667 13.3208L3.38583 12.1667H15.25V2.16667H1.91667V13.3208ZM9.41667 7.16667V10.5H7.75V7.16667H5.25L8.58333 3.83333L11.9167 7.16667H9.41667Z",
    fill: "#6B6B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostMessage);
export default __webpack_public_path__ + "static/media/postMessage.d66549378f1299ae0286d4184c138ea9.svg";
export { ForwardRef as ReactComponent };